var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sky__checkbox flex items-center cursor-pointer select-none",on:{"click":_vm.toggleValue}},[_c('div',{staticClass:"bg-sky_grey",class:{
      'bg-sky_grey': !_vm.internalValue,
      'bg-sky_secondary': _vm.internalValue
    },style:({
      width: '18px',
      height: '18px'
    })},[(_vm.internalValue)?_c('icon-check',{staticStyle:{"width":"25px","position":"relative","left":"-4px","top":"-3px"},attrs:{"color":"white"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"ml-2",class:_vm.xxs ? 'text-xs' : 'text-sm'},[_vm._t("label",function(){return [_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }